var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors;
  return {
    buttonsZIndex: '3333',
    buttonsColor: colors.oxford,
    buttonsPadding: spacing.xSmall
  };
};
export default generateComponentTheme;